var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#calendar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 2.25V4.5M12.375 2.25V4.5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 12.375,
    x: 2.25,
    y: 3.375,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.25h6.75M12 12.75h.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export { SvgCalendar as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTA1NGVkYjE0NTMzYmFlMjU1NGM5OTgyYzFmZmM2MzAuc3ZnIjs=";